import { referrerUrl } from "components/initializers/ReferrerCounter.model";
import AppLang from "components/other/AppLang";
import { fromGlobalId } from "graphql-relay";
import { useViewerQuery } from "queries/viewerQuery";
import { useEffectOnce } from "react-use";
import styled from "styled-components";
import { isApp, topPadding } from "tools/device";

const Wrap = styled.div`
  position: absolute;
  top: ${topPadding}px;
`;

const Welcome: React.FC = () => {
  const { viewer } = useViewerQuery();

  /**
   * webFunnelSelf
   *  - this will create row in referrer table when in browser
   *  - after user installs the app, it will log him in thanks to prelogin method in auth.ts
   */
  useEffectOnce(() => {
    if (isApp()) return;

    fetch(referrerUrl({ referrer: "webFunnelSelf", noredirect: true, webFunnelUserId: fromGlobalId(viewer?.id!).id }));
  });

  return (
    <Wrap>
      <AppLang />
    </Wrap>
  );
};

export default Welcome;
